import { jsxs as _jsxs } from "react/jsx-runtime";
import cx from "classnames";
import { Text } from "@cinch-labs/design-system";
import styles from "./admin-fee-button.module.css";
import skeletonStyles from "../../skeleton.module.css";
import { Env, readFromEnv } from "@cinch-nx/environments";
const AdminFeeButton = ({ onAdminFeeClick , isPending  })=>{
    const adminFeeValueInPence = readFromEnv(Env.AdminFeeValue);
    const formatAdminFeeValue = ()=>{
        const adminFeeValue = Number.parseInt(adminFeeValueInPence) / 100;
        if (!Number.isNaN(adminFeeValue)) {
            return `£${adminFeeValue}`;
        }
        return "";
    };
    const handleClick = (e)=>{
        e.stopPropagation();
        if (onAdminFeeClick) onAdminFeeClick();
    };
    const ariaLabel = `Includes ${formatAdminFeeValue()} admin fee. Find out more info`;
    return /*#__PURE__*/ _jsxs(Text, {
        fontSizeFixed: "xs",
        element: "button",
        disabled: isPending,
        onClick: handleClick,
        "aria-label": ariaLabel,
        className: cx(styles["adminFeeInfoButton"], {
            [skeletonStyles["base"]]: isPending,
            [skeletonStyles["active"]]: isPending
        }),
        "data-testid": "admin-fee",
        children: [
            "Includes ",
            formatAdminFeeValue(),
            " admin fee"
        ]
    });
};
export default AdminFeeButton;
